export const LogoMark = ({ size = 30 }) => (
  <img
    src="/logo-mark.png"
    alt="Proaura"
    style={{ height: size, width: "auto" }}
    aria-hidden="true"
  />
);

export default function Logo({ compact = false }) {
  return (
    <div className="flex items-center" data-testid="proaura-logo">
      <img
        src={compact ? "/logo-mark.png" : "/logo.png"}
        alt="Proaura"
        className={`w-auto ${compact ? "h-6" : "h-8"}`}
      />
    </div>
  );
}
